import { DataService } from "@/services/data";
import { ApprenticeshipOfferType } from "@/types/apprenticeship/enterprise";

/**
 * CRM `/accounts/<id>` page of a legacy apprenticeship company. Every Company mirrors an
 * SFAccount (`Company.sf_account`), serialized either as a pk or as an `{ id }` object.
 */
export function accountHref(sfAccount: number | { id?: number | null } | null | undefined): string {
    const id = typeof sfAccount === "object" ? sfAccount?.id : sfAccount;
    return id ? `/accounts/${id}` : "/accounts";
}

/** Where a hidden `/apprenticeship-offers/:id` URL lands: the mirrored opportunity, else the account. */
export async function legacyOfferHref(offerId: string): Promise<string> {
    const offer = (await DataService.client.url(`/apprenticeship/offers/${offerId}/`).get().json()) as ApprenticeshipOfferType;
    return offer.opportunity ? `/opportunities/${offer.opportunity}` : accountHref(offer.company?.sf_account);
}
